/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { BulkSelection } from './bulkSelection';

export interface AddFromSearchRequest {
  profile_ids?: string[] | null;
  search_id?: string | null;
  arbitrator_session_id?: string | null;
  bulk?: BulkSelection | null;
  min_score?: number | null;
  q?: string | null;
  stage_id?: string | null;
}
